import { pathSatisfies } from 'ramda'
import { SUBSCRIPTION_STATUS } from '../../../../../constants'

export const statusIneligible = pathSatisfies(
  status => status === SUBSCRIPTION_STATUS.NONE,
  ['subscription', 'status']
)
